var _defs, _rect, _rect2, _g, _ellipse, _rect3, _rect4, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarFooterArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 190,
    viewBox: "0 0 420 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "night",
    x1: 0,
    y1: 0,
    x2: 420,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24124C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "haze",
    x1: 210,
    y1: 45,
    x2: 210,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C71D6",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4A9C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "road",
    x1: 0,
    y1: 116,
    x2: 420,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5AB3",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9758CC",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "truckBody",
    x1: 72,
    y1: 93,
    x2: 220,
    y2: 145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7989EF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lampGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(252 92) rotate(90) scale(46 120)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4BDFF",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BDFF",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 190,
    fill: "url(#night)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 190,
    fill: "url(#haze)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 34,
    width: 30,
    height: 70,
    rx: 5,
    fill: "#2F2F78"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 28,
    width: 34,
    height: 76,
    rx: 5,
    fill: "#373983"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 22,
    width: 36,
    height: 82,
    rx: 6,
    fill: "#3D408B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363,
    y: 30,
    width: 24,
    height: 74,
    rx: 5,
    fill: "#32357C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 18,
    width: 8,
    height: 10,
    rx: 2,
    fill: "#9AA9FF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 11,
    width: 8,
    height: 11,
    rx: 2,
    fill: "#A0AFFF",
    opacity: 0.6
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 258,
    cy: 90,
    rx: 130,
    ry: 54,
    fill: "url(#lampGlow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 118,
    width: 420,
    height: 72,
    fill: "url(#road)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 140,
    width: 420,
    height: 50,
    fill: "#1C245B",
    opacity: 0.62
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 99,
    width: 108,
    height: 34,
    rx: 6,
    fill: "url(#truckBody)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 105,
    width: 33,
    height: 28,
    rx: 4,
    fill: "#8FA1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 110,
    width: 16,
    height: 10,
    rx: 2,
    fill: "#DCE3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 106,
    width: 22,
    height: 7,
    rx: 2,
    fill: "#EEF2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 106,
    width: 26,
    height: 7,
    rx: 2,
    fill: "#EEF2FF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 121H224L227 129H216V121Z",
    fill: "#8B9BFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 141,
    r: 10,
    fill: "#151B47"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 141,
    r: 5.4,
    fill: "#7B8CF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 141,
    r: 10,
    fill: "#151B47"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 141,
    r: 5.4,
    fill: "#7B8CF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 141,
    r: 9.4,
    fill: "#151B47"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 141,
    r: 5,
    fill: "#7B8CF1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 149H64",
    stroke: "#B7C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 149H274",
    stroke: "#B7C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 149H326",
    stroke: "#B7C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 149H378",
    stroke: "#B7C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFooterArt);
export default __webpack_public_path__ + "static/media/sidebar-footer-art.562c88700a99267ba2e344019d58e07e.svg";
export { ForwardRef as ReactComponent };